import { useState, createContext, useContext } from "react";

export const RunProfileReportFileIdContext = createContext({});
export const useRunReportFileIdContext = () =>
  useContext(RunProfileReportFileIdContext);

/***
 * USAGE: Provides a fileIdToRunProfileReport to the following components, and thus allowing users to run a profile report on a successfully uploaded file.:
 * -  file_uploader
 * -  fsa_map
 * -  map_radius
 * -  merge_files
 */
function RunProfileReportFileIdProvider({ children }) {
  const [fileIdToRunProfileReport, setFileIdToRunProfileReport] =
    useState(undefined);
  const props = {
    fileIdToRunProfileReport,
    setFileIdToRunProfileReport,
  };
  return (
    <RunProfileReportFileIdContext.Provider value={props}>
      {children}
    </RunProfileReportFileIdContext.Provider>
  );
}

export default RunProfileReportFileIdProvider;
